import { enGB } from "date-fns/locale";
import { i18n } from "./i18n";
import { setDefaultYupTranslations } from "./setDefaultYupTranslations";
const DEFAULT_LANGUAGE_KEY = "en";
const SUPPORTED_LANGUAGES = [
    {
        key: DEFAULT_LANGUAGE_KEY,
        value: "English",
    },
    {
        key: "sv-SE",
        value: "Svenska (Sverige)",
    },
    {
        key: "de-DE",
        value: "Deutsch (Deutschland)",
    },
    {
        key: "fr-CH",
        value: "Français (Suisse)",
    },
    {
        key: "fr-FR",
        value: "Français (France)",
    },
    {
        key: "fr-BE",
        value: "Français (Belgique)",
    },
    {
        key: "it-CH",
        value: "Italiano (Svizzera)",
    },
    {
        key: "ja-JP",
        value: "日本語 (日本)",
    },
    {
        key: "ko-KR",
        value: "한국어 (대한민국)",
    },
    {
        key: "nb-NO",
        value: "Norsk bokmål (Norge)",
    },
    {
        key: "nl-BE",
        value: "Nederlands (België)",
    },
    {
        key: "pt-PT",
        value: "Português (Portugal)",
    },
    {
        key: "zh-CN",
        value: "中文 (中国)",
    },
];
const supportedLanguages = Object.values(SUPPORTED_LANGUAGES).map(({ key }) => key);
export const getSupportedLanguage = (value) => {
    if (!supportedLanguages.includes(value)) {
        return DEFAULT_LANGUAGE_KEY;
    }
    return value;
};
export const addLanguageBundlesStandalone = async (lang) => {
    const resources = await (await fetch(`/locales/${lang}.json?t=${Date.now()}`)).json();
    i18n.addResourceBundle(lang, "common", resources, true);
    await i18n.changeLanguage(lang);
    setDefaultYupTranslations();
};
export const addLanguageBundlesParcel = async (lang) => {
    let resources = await import("../../locales/en.json");
    if (lang === "sv-SE") {
        resources = await import("../../locales/sv-SE.json");
    }
    if (lang === "de-DE") {
        resources = await import("../../locales/de-DE.json");
    }
    if (lang === "fr-CH") {
        resources = await import("../../locales/fr-CH.json");
    }
    if (lang === "fr-FR") {
        resources = await import("../../locales/fr-FR.json");
    }
    if (lang === "fr-BE") {
        resources = await import("../../locales/fr-BE.json");
    }
    if (lang === "it-CH") {
        resources = await import("../../locales/it-CH.json");
    }
    if (lang === "ja-JP") {
        resources = await import("../../locales/ja-JP.json");
    }
    if (lang === "ko-KR") {
        resources = await import("../../locales/ko-KR.json");
    }
    if (lang === "nb-NO") {
        resources = await import("../../locales/nb-NO.json");
    }
    if (lang === "nl-BE") {
        resources = await import("../../locales/nl-BE.json");
    }
    if (lang === "pt-PT") {
        resources = await import("../../locales/pt-PT.json");
    }
    if (lang === "zh-CN") {
        resources = await import("../../locales/zh-CN.json");
    }
    i18n.addResourceBundle(lang, "common", resources, true);
    await i18n.changeLanguage(lang);
    setDefaultYupTranslations();
};
export function getCurrentLocale() {
    const lang = i18n.language;
    if (lang === "en-GB" || lang === "en") {
        return enGB;
    }
    return enGB;
}
//# sourceMappingURL=language.js.map